import React from 'react';
import { useTranslation } from 'react-i18next';
import { VerticalBarChart } from '@fluentui/react-charting';
import './BarFluentWidget.css';

const BarFluentWidget = ({ data, config }) => {
    const { t } = useTranslation();

    console.log('📊 BarFluentWidget received:', { data, config });

    // Extract configuration
    const xAxisKey = config?.config?.xAxisKey || config?.xAxisKey || 'category';
    const yAxisKey = config?.config?.yAxisKey || config?.yAxisKey || 'value';
    const targetLine = config?.config?.targetLine || config?.targetLine;
    const maxLine = config?.config?.maxLine || config?.maxLine;

    // Ensure data is an array
    const chartData = Array.isArray(data) ? data : [];

    if (chartData.length === 0) {
        return (
            <div className="bar-fluent-empty">
                <p>{t('NO_DATA_AVAILABLE')}</p>
            </div>
        );
    }

    // Extract target and max values from the data
    const targetValue = chartData.find(item => item.category === 'Target')?.value;
    const maxValue = chartData.find(item => item.category === 'Maximum')?.value;
    const currentValue = chartData.find(item => item.category === 'Current Average')?.value;

    // Function to determine bar color based on thresholds
    function getBarColor(category, value) {
        if (category === 'Current Average') {
            if (!targetValue || !maxValue) return '#0078D4'; // Default blue
            if (value <= targetValue) return '#107C10'; // Green - within target
            if (value <= maxValue) return '#FFB900'; // Yellow - approaching max
            return '#D13438'; // Red - exceeds max
        }
        if (category === 'Target') return '#107C10'; // Green line
        if (category === 'Maximum') return '#D13438'; // Red line
        return '#0078D4'; // Default blue
    }

    // Transform data for Fluent UI VerticalBarChart
    const fluentChartData = chartData.map(item => ({
        x: item[xAxisKey] || '',
        y: item[yAxisKey] || 0,
        legend: item[xAxisKey] || '',
        color: getBarColor(item[xAxisKey], item[yAxisKey])
    }));

    console.log('🎨 Chart data with colors:', fluentChartData);

    // Calculate chart dimensions based on data
    const barWidth = Math.max(60, Math.min(100, 400 / chartData.length));

    return (
        <div className="bar-fluent-widget">
            <VerticalBarChart
                data={fluentChartData}
                width="100%"
                height={220}
                barWidth={barWidth}
                yAxisTickCount={5}
                hideLegend={false}
                hideTooltip={false}
                enableReflow={true}
            />
            {(targetLine || maxLine) && (
                <div className="bar-legend">
                    {targetLine && (
                        <div className="legend-item">
                            <span className="legend-color" style={{ backgroundColor: '#107C10' }}></span>
                            <span>{t('WITHIN_TARGET')}</span>
                        </div>
                    )}
                    {maxLine && (
                        <>
                            <div className="legend-item">
                                <span className="legend-color" style={{ backgroundColor: '#FFB900' }}></span>
                                <span>{t('APPROACHING_MAX')}</span>
                            </div>
                            <div className="legend-item">
                                <span className="legend-color" style={{ backgroundColor: '#D13438' }}></span>
                                <span>{t('EXCEEDS_MAX')}</span>
                            </div>
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

export default BarFluentWidget;
